import React from "react";
import { Button, Dropdown } from "react-bootstrap";
import HoverTooltip from "../hovertooltip/hovertooltip";
import { ExportIcon } from "../icons";
import "./export-button.scss";

const ExportButton = ({ onExport, mpngStyle, includeCSV = true, includePDF = true }) => {
  const handleExportClick = (action) => {
    onExport(action);
  };

  let tooltip = "",
    buttonCount = 0,
    action = "";
  if (includeCSV) {
    tooltip = "Export CSV";
    buttonCount++;
    action = "csv";
  }
  if (includePDF) {
    tooltip = "Export PDF";
    buttonCount++;
    action = "pdf";
  }
  if (includeCSV && includePDF) {
    tooltip = "Export CSV or PDF";
  }

  const addMpngClass = (className) => `${className} ${mpngStyle ? "mpng-style" : ""}`;

  if (buttonCount === 1) {
    return (
      <div className={addMpngClass("csr-header-export-button")} data-testid="mpng-container-export-button">
        <HoverTooltip help={tooltip} className={addMpngClass("export-button-tooltip")}>
          <Button className="csr-export-button-button " onClick={() => handleExportClick(action)}>
            <ExportIcon />
          </Button>
        </HoverTooltip>
      </div>
    );
  } else if (buttonCount > 1) {
    return (
      <div className={addMpngClass("csr-header-export-button")} data-testid="mpng-container-export-button">
        <Dropdown>
          <HoverTooltip help={tooltip} className={addMpngClass("export-button-tooltip")}>
            <Dropdown.Toggle
              className="csr-export-button-button"
              aria-label="Export button"
              data-testid="mpng-export-button"
            >
              <ExportIcon />
            </Dropdown.Toggle>
          </HoverTooltip>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleExportClick("csv")}>Export CSV</Dropdown.Item>
            <Dropdown.Item onClick={() => handleExportClick("pdf")}>Export PDF</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
};

export default ExportButton;
